import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { FloppyDisk } from "@phosphor-icons/react";

export default function CurrencyAdmin() {
  const [cfg, setCfg] = useState({ base: "INR", rates: { INR: 1, AED: 0.043, EUR: 0.011 } });

  useEffect(() => {
    api.get("/currency").then((r) => setCfg(r.data));
  }, []);

  const setRate = (k, v) => setCfg((s) => ({ ...s, rates: { ...s.rates, [k]: Number(v) } }));

  const save = async () => {
    try {
      await api.put("/currency", { base: cfg.base, rates: cfg.rates });
      toast.success("Rates saved");
    } catch { toast.error("Save failed"); }
  };

  return (
    <div data-testid="admin-currency" className="p-8 md:p-10">
      <h1 className="font-display font-black text-3xl md:text-4xl">Currency & rates</h1>
      <p className="mt-2 text-neutral-600">Base currency is <span className="font-mono">INR</span>. Set static multipliers used everywhere on the site.</p>

      <div className="mt-8 max-w-2xl bg-white border border-[color:var(--line)] p-6 space-y-5">
        {Object.entries(cfg.rates).map(([k, v]) => (
          <div key={k} className="grid grid-cols-4 items-center gap-4">
            <div className="font-display font-bold text-lg">{k}</div>
            <div className="col-span-2">
              <input type="number" step="0.0001" value={v} onChange={(e) => setRate(k, e.target.value)}
                data-testid={`rate-${k}`}
                className="w-full border border-[color:var(--line)] px-4 py-2.5 outline-none focus:border-[color:var(--brand)]" />
            </div>
            <div className="text-xs text-neutral-500 font-mono">1 INR = {v} {k}</div>
          </div>
        ))}
        <div className="pt-3 flex justify-end">
          <button onClick={save} data-testid="currency-save" className="btn-brand text-sm py-2.5 px-4">
            <FloppyDisk size={14} weight="bold" /> Save rates
          </button>
        </div>
      </div>
    </div>
  );
}
